import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _7926df98 = () => interopDefault(import('../../../pages/404-error/index.vue' /* webpackChunkName: "pages/404-error/index" */))
const _e4479af4 = () => interopDefault(import('../../../pages/app/index.vue' /* webpackChunkName: "pages/app/index" */))
const _0e3944b6 = () => interopDefault(import('../../../pages/buy-sell-your-home/index.vue' /* webpackChunkName: "pages/buy-sell-your-home/index" */))
const _406c9257 = () => interopDefault(import('../../../pages/buy-your-home/index.vue' /* webpackChunkName: "pages/buy-your-home/index" */))
const _f082a6e2 = () => interopDefault(import('../../../pages/calendar/index.vue' /* webpackChunkName: "pages/calendar/index" */))
const _722aa898 = () => interopDefault(import('../../../pages/commissions-calculator/index.vue' /* webpackChunkName: "pages/commissions-calculator/index" */))
const _29d51b3e = () => interopDefault(import('../../../pages/comparables/index.vue' /* webpackChunkName: "pages/comparables/index" */))
const _68a654c5 = () => interopDefault(import('../../../pages/contact/index.vue' /* webpackChunkName: "pages/contact/index" */))
const _57e7553b = () => interopDefault(import('../../../pages/faq/index.vue' /* webpackChunkName: "pages/faq/index" */))
const _3961e9bb = () => interopDefault(import('../../../pages/favourites/index.vue' /* webpackChunkName: "pages/favourites/index" */))
const _8211955a = () => interopDefault(import('../../../pages/list-home/index.vue' /* webpackChunkName: "pages/list-home/index" */))
const _65feb906 = () => interopDefault(import('../../../pages/listing-management/index.vue' /* webpackChunkName: "pages/listing-management/index" */))
const _704d334e = () => interopDefault(import('../../../pages/login/index.vue' /* webpackChunkName: "pages/login/index" */))
const _6f178080 = () => interopDefault(import('../../../pages/market-data/index.vue' /* webpackChunkName: "pages/market-data/index" */))
const _d7f20dc6 = () => interopDefault(import('../../../pages/messages/index.vue' /* webpackChunkName: "pages/messages/index" */))
const _50ef1706 = () => interopDefault(import('../../../pages/my-abode-overview/index.vue' /* webpackChunkName: "pages/my-abode-overview/index" */))
const _62e4a515 = () => interopDefault(import('../../../pages/my-listings/index.vue' /* webpackChunkName: "pages/my-listings/index" */))
const _4f06fecb = () => interopDefault(import('../../../pages/offer-management-buyer/index.vue' /* webpackChunkName: "pages/offer-management-buyer/index" */))
const _0f6b01bd = () => interopDefault(import('../../../pages/offer-management-seller/index.vue' /* webpackChunkName: "pages/offer-management-seller/index" */))
const _b73405b0 = () => interopDefault(import('../../../pages/offers/index.vue' /* webpackChunkName: "pages/offers/index" */))
const _e893edfc = () => interopDefault(import('../../../pages/offers-old/index.vue' /* webpackChunkName: "pages/offers-old/index" */))
const _10e6322d = () => interopDefault(import('../../../pages/privacy/index.vue' /* webpackChunkName: "pages/privacy/index" */))
const _51afbb7b = () => interopDefault(import('../../../pages/pro-edit/index.vue' /* webpackChunkName: "pages/pro-edit/index" */))
const _09baa810 = () => interopDefault(import('../../../pages/pro-marketplace/index.vue' /* webpackChunkName: "pages/pro-marketplace/index" */))
const _0dc8e819 = () => interopDefault(import('../../../pages/pro-search/index.vue' /* webpackChunkName: "pages/pro-search/index" */))
const _ef864838 = () => interopDefault(import('../../../pages/request-sticker/index.vue' /* webpackChunkName: "pages/request-sticker/index" */))
const _aa2fe00e = () => interopDefault(import('../../../pages/search/index.vue' /* webpackChunkName: "pages/search/index" */))
const _9bbefb62 = () => interopDefault(import('../../../pages/sell-your-home/index.vue' /* webpackChunkName: "pages/sell-your-home/index" */))
const _55c0e12e = () => interopDefault(import('../../../pages/signup/index.vue' /* webpackChunkName: "pages/signup/index" */))
const _08211130 = () => interopDefault(import('../../../pages/sold-data/index.vue' /* webpackChunkName: "pages/sold-data/index" */))
const _28ab7154 = () => interopDefault(import('../../../pages/terms-of-service/index.vue' /* webpackChunkName: "pages/terms-of-service/index" */))
const _712b572d = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _44c63899 = () => interopDefault(import('../../../pages/whoweare/index.vue' /* webpackChunkName: "pages/whoweare/index" */))
const _14e61f84 = () => interopDefault(import('../../../pages/why-bode/index.vue' /* webpackChunkName: "pages/why-bode/index" */))
const _410da6d4 = () => interopDefault(import('../../../pages/admin/conversation/index.vue' /* webpackChunkName: "pages/admin/conversation/index" */))
const _b272f336 = () => interopDefault(import('../../../pages/admin/offer-management/index.vue' /* webpackChunkName: "pages/admin/offer-management/index" */))
const _b5142642 = () => interopDefault(import('../../../pages/admin/showings/index.vue' /* webpackChunkName: "pages/admin/showings/index" */))
const _510c249a = () => interopDefault(import('../../../pages/listings/review.vue' /* webpackChunkName: "pages/listings/review" */))
const _1e034318 = () => interopDefault(import('../../../pages/login/idp/index.vue' /* webpackChunkName: "pages/login/idp/index" */))
const _3052c38e = () => interopDefault(import('../../../pages/login/reset/index.vue' /* webpackChunkName: "pages/login/reset/index" */))
const _19fc35e6 = () => interopDefault(import('../../../pages/offers-old/constants/index.js' /* webpackChunkName: "pages/offers-old/constants/index" */))
const _71b7ba2a = () => interopDefault(import('../../../pages/offers-old/enums/index.js' /* webpackChunkName: "pages/offers-old/enums/index" */))
const _4aa0fa6b = () => interopDefault(import('../../../pages/offers/submit-success/index.vue' /* webpackChunkName: "pages/offers/submit-success/index" */))
const _b4401802 = () => interopDefault(import('../../../pages/offers/summary/index.vue' /* webpackChunkName: "pages/offers/summary/index" */))
const _6abf2995 = () => interopDefault(import('../../../pages/pro-edit/profile/index.vue' /* webpackChunkName: "pages/pro-edit/profile/index" */))
const _62f6f0be = () => interopDefault(import('../../../pages/pro-edit/service/index.vue' /* webpackChunkName: "pages/pro-edit/service/index" */))
const _0736a961 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/index" */))
const _defd636c = () => interopDefault(import('../../../pages/pro-marketplace/pro-login/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-login/index" */))
const _dff85b7e = () => interopDefault(import('../../../pages/pro-marketplace/pro-portal/index.vue' /* webpackChunkName: "pages/pro-marketplace/pro-portal/index" */))
const _1674cf78 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/index" */))
const _775351de = () => interopDefault(import('../../../pages/pro-marketplace/service-requests/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-requests/index" */))
const _2927fbf2 = () => interopDefault(import('../../../pages/search/saved-search-list/index.vue' /* webpackChunkName: "pages/search/saved-search-list/index" */))
const _78c85842 = () => interopDefault(import('../../../pages/signup/additional-information/index.vue' /* webpackChunkName: "pages/signup/additional-information/index" */))
const _0c695bda = () => interopDefault(import('../../../pages/signup/confirm/index.vue' /* webpackChunkName: "pages/signup/confirm/index" */))
const _aca81d2c = () => interopDefault(import('../../../pages/admin/listings/import/index.vue' /* webpackChunkName: "pages/admin/listings/import/index" */))
const _02fccce4 = () => interopDefault(import('../../../pages/admin/listings/update/index.vue' /* webpackChunkName: "pages/admin/listings/update/index" */))
const _3dfe3d42 = () => interopDefault(import('../../../pages/ds/callback/listing/index.vue' /* webpackChunkName: "pages/ds/callback/listing/index" */))
const _3d5e8337 = () => interopDefault(import('../../../pages/ds/callback/offer/index.vue' /* webpackChunkName: "pages/ds/callback/offer/index" */))
const _a0f68146 = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/index" */))
const _ba1dc118 = () => interopDefault(import('../../../pages/pro-marketplace/service-request/photography-measurements/index.vue' /* webpackChunkName: "pages/pro-marketplace/service-request/photography-measurements/index" */))
const _14df2e3b = () => interopDefault(import('../../../pages/admin/listings/update/form/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/index" */))
const _0eb2c58d = () => interopDefault(import('../../../pages/admin/listings/update/table/index.vue' /* webpackChunkName: "pages/admin/listings/update/table/index" */))
const _bc37133c = () => interopDefault(import('../../../pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index.vue' /* webpackChunkName: "pages/pro-marketplace/marketplace-for-pros/pro-sign-up/successful/index" */))
const _aca6e018 = () => interopDefault(import('../../../pages/admin/listings/update/form/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/form/constants/index" */))
const _5d89f9ef = () => interopDefault(import('../../../pages/admin/listings/update/form/controls/index.js' /* webpackChunkName: "pages/admin/listings/update/form/controls/index" */))
const _75b91eb4 = () => interopDefault(import('../../../pages/admin/listings/update/form/listing-item/index.vue' /* webpackChunkName: "pages/admin/listings/update/form/listing-item/index" */))
const _55441051 = () => interopDefault(import('../../../pages/admin/listings/update/services/AdminUpdateListingTableMapService.js' /* webpackChunkName: "pages/admin/listings/update/services/AdminUpdateListingTableMapService" */))
const _de510432 = () => interopDefault(import('../../../pages/admin/listings/update/table/checkbox-cell.vue' /* webpackChunkName: "pages/admin/listings/update/table/checkbox-cell" */))
const _c30dd63c = () => interopDefault(import('../../../pages/admin/listings/update/table/constants/index.js' /* webpackChunkName: "pages/admin/listings/update/table/constants/index" */))
const _28821c7f = () => interopDefault(import('../../../pages/admin/listings/update/table/enums/index.js' /* webpackChunkName: "pages/admin/listings/update/table/enums/index" */))
const _139c47e2 = () => interopDefault(import('../../../pages/admin/listings/update/table/header.vue' /* webpackChunkName: "pages/admin/listings/update/table/header" */))
const _b2379372 = () => interopDefault(import('../../../pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps.js' /* webpackChunkName: "pages/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps" */))
const _495b2715 = () => interopDefault(import('../../../pages/pro-marketplace/profile/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/profile/_id/index" */))
const _dcdc5a72 = () => interopDefault(import('../../../pages/pro-marketplace/view-request/_id/index.vue' /* webpackChunkName: "pages/pro-marketplace/view-request/_id/index" */))
const _84cdc1e0 = () => interopDefault(import('../../../pages/buyer-checklist/_page/index.vue' /* webpackChunkName: "pages/buyer-checklist/_page/index" */))
const _30a5f0b9 = () => interopDefault(import('../../../pages/how-it-works/_id/index.vue' /* webpackChunkName: "pages/how-it-works/_id/index" */))
const _e8976fc2 = () => interopDefault(import('../../../pages/listing-editing/_id/index.vue' /* webpackChunkName: "pages/listing-editing/_id/index" */))
const _3796cd2a = () => interopDefault(import('../../../pages/listings/_id/index.vue' /* webpackChunkName: "pages/listings/_id/index" */))
const _bc2e2406 = () => interopDefault(import('../../../pages/pro/_id/index.vue' /* webpackChunkName: "pages/pro/_id/index" */))
const _52399708 = () => interopDefault(import('../../../pages/seller-checklist/_page/index.vue' /* webpackChunkName: "pages/seller-checklist/_page/index" */))
const _22f9c7b7 = () => interopDefault(import('../../../pages/settings/_section/index.vue' /* webpackChunkName: "pages/settings/_section/index" */))
const _2bbf5bbe = () => interopDefault(import('../../../pages/sold-property/_id/index.vue' /* webpackChunkName: "pages/sold-property/_id/index" */))
const _460128c7 = () => interopDefault(import('../../../pages/user/_id/index.vue' /* webpackChunkName: "pages/user/_id/index" */))
const _3fe3c112 = () => interopDefault(import('../../../pages/listings/_id/audit/index.vue' /* webpackChunkName: "pages/listings/_id/audit/index" */))
const _ecdbdb20 = () => interopDefault(import('../../../pages/listings/_id/dashboard/index.vue' /* webpackChunkName: "pages/listings/_id/dashboard/index" */))
const _bd182070 = () => interopDefault(import('../../../pages/listings/_id/submit-success/index.vue' /* webpackChunkName: "pages/listings/_id/submit-success/index" */))
const _7fbfdd68 = () => interopDefault(import('../../../pages/offers-old/_id/agreement/index.vue' /* webpackChunkName: "pages/offers-old/_id/agreement/index" */))
const _59f7e495 = () => interopDefault(import('../../../pages/settings/_section/enums/index.js' /* webpackChunkName: "pages/settings/_section/enums/index" */))
const _7a1a245f = () => interopDefault(import('../../../pages/listings/_id/dashboard/enums.js' /* webpackChunkName: "pages/listings/_id/dashboard/enums" */))
const _34ceffba = () => interopDefault(import('../../../pages/listings/_id/viewings/_type/index.vue' /* webpackChunkName: "pages/listings/_id/viewings/_type/index" */))
const _f265905a = () => interopDefault(import('../../../pages/users/_id/_section/index.vue' /* webpackChunkName: "pages/users/_id/_section/index" */))
const _0e3d8418 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/404-error",
    component: _7926df98,
    name: "404-error"
  }, {
    path: "/app",
    component: _e4479af4,
    name: "app"
  }, {
    path: "/buy-sell-your-home",
    component: _0e3944b6,
    name: "buy-sell-your-home"
  }, {
    path: "/buy-your-home",
    component: _406c9257,
    name: "buy-your-home"
  }, {
    path: "/calendar",
    component: _f082a6e2,
    name: "calendar"
  }, {
    path: "/commissions-calculator",
    component: _722aa898,
    name: "commissions-calculator"
  }, {
    path: "/comparables",
    component: _29d51b3e,
    name: "comparables"
  }, {
    path: "/contact",
    component: _68a654c5,
    name: "contact"
  }, {
    path: "/faq",
    component: _57e7553b,
    name: "faq"
  }, {
    path: "/favourites",
    component: _3961e9bb,
    name: "favourites"
  }, {
    path: "/list-home",
    component: _8211955a,
    name: "list-home"
  }, {
    path: "/listing-management",
    component: _65feb906,
    name: "listing-management"
  }, {
    path: "/login",
    component: _704d334e,
    name: "login"
  }, {
    path: "/market-data",
    component: _6f178080,
    name: "market-data"
  }, {
    path: "/messages",
    component: _d7f20dc6,
    name: "messages"
  }, {
    path: "/my-abode-overview",
    component: _50ef1706,
    name: "my-abode-overview"
  }, {
    path: "/my-listings",
    component: _62e4a515,
    name: "my-listings"
  }, {
    path: "/offer-management-buyer",
    component: _4f06fecb,
    name: "offer-management-buyer"
  }, {
    path: "/offer-management-seller",
    component: _0f6b01bd,
    name: "offer-management-seller"
  }, {
    path: "/offers",
    component: _b73405b0,
    name: "offers"
  }, {
    path: "/offers-old",
    component: _e893edfc,
    name: "offers-old"
  }, {
    path: "/privacy",
    component: _10e6322d,
    name: "privacy"
  }, {
    path: "/pro-edit",
    component: _51afbb7b,
    name: "pro-edit"
  }, {
    path: "/pro-marketplace",
    component: _09baa810,
    name: "pro-marketplace"
  }, {
    path: "/pro-search",
    component: _0dc8e819,
    name: "pro-search"
  }, {
    path: "/request-sticker",
    component: _ef864838,
    name: "request-sticker"
  }, {
    path: "/search",
    component: _aa2fe00e,
    name: "search"
  }, {
    path: "/sell-your-home",
    component: _9bbefb62,
    name: "sell-your-home"
  }, {
    path: "/signup",
    component: _55c0e12e,
    name: "signup"
  }, {
    path: "/sold-data",
    component: _08211130,
    name: "sold-data"
  }, {
    path: "/terms-of-service",
    component: _28ab7154,
    name: "terms-of-service"
  }, {
    path: "/users",
    component: _712b572d,
    name: "users"
  }, {
    path: "/whoweare",
    component: _44c63899,
    name: "whoweare"
  }, {
    path: "/why-bode",
    component: _14e61f84,
    name: "why-bode"
  }, {
    path: "/admin/conversation",
    component: _410da6d4,
    name: "admin-conversation"
  }, {
    path: "/admin/offer-management",
    component: _b272f336,
    name: "admin-offer-management"
  }, {
    path: "/admin/showings",
    component: _b5142642,
    name: "admin-showings"
  }, {
    path: "/listings/review",
    component: _510c249a,
    name: "listings-review"
  }, {
    path: "/login/idp",
    component: _1e034318,
    name: "login-idp"
  }, {
    path: "/login/reset",
    component: _3052c38e,
    name: "login-reset"
  }, {
    path: "/offers-old/constants",
    component: _19fc35e6,
    name: "offers-old-constants"
  }, {
    path: "/offers-old/enums",
    component: _71b7ba2a,
    name: "offers-old-enums"
  }, {
    path: "/offers/submit-success",
    component: _4aa0fa6b,
    name: "offers-submit-success"
  }, {
    path: "/offers/summary",
    component: _b4401802,
    name: "offers-summary"
  }, {
    path: "/pro-edit/profile",
    component: _6abf2995,
    name: "pro-edit-profile"
  }, {
    path: "/pro-edit/service",
    component: _62f6f0be,
    name: "pro-edit-service"
  }, {
    path: "/pro-marketplace/marketplace-for-pros",
    component: _0736a961,
    name: "pro-marketplace-marketplace-for-pros"
  }, {
    path: "/pro-marketplace/pro-login",
    component: _defd636c,
    name: "pro-marketplace-pro-login"
  }, {
    path: "/pro-marketplace/pro-portal",
    component: _dff85b7e,
    name: "pro-marketplace-pro-portal"
  }, {
    path: "/pro-marketplace/service-request",
    component: _1674cf78,
    name: "pro-marketplace-service-request"
  }, {
    path: "/pro-marketplace/service-requests",
    component: _775351de,
    name: "pro-marketplace-service-requests"
  }, {
    path: "/search/saved-search-list",
    component: _2927fbf2,
    name: "search-saved-search-list"
  }, {
    path: "/signup/additional-information",
    component: _78c85842,
    name: "signup-additional-information"
  }, {
    path: "/signup/confirm",
    component: _0c695bda,
    name: "signup-confirm"
  }, {
    path: "/admin/listings/import",
    component: _aca81d2c,
    name: "admin-listings-import"
  }, {
    path: "/admin/listings/update",
    component: _02fccce4,
    name: "admin-listings-update"
  }, {
    path: "/ds/callback/listing",
    component: _3dfe3d42,
    name: "ds-callback-listing"
  }, {
    path: "/ds/callback/offer",
    component: _3d5e8337,
    name: "ds-callback-offer"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up",
    component: _a0f68146,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up"
  }, {
    path: "/pro-marketplace/service-request/photography-measurements",
    component: _ba1dc118,
    name: "pro-marketplace-service-request-photography-measurements"
  }, {
    path: "/admin/listings/update/form",
    component: _14df2e3b,
    name: "admin-listings-update-form"
  }, {
    path: "/admin/listings/update/table",
    component: _0eb2c58d,
    name: "admin-listings-update-table"
  }, {
    path: "/pro-marketplace/marketplace-for-pros/pro-sign-up/successful",
    component: _bc37133c,
    name: "pro-marketplace-marketplace-for-pros-pro-sign-up-successful"
  }, {
    path: "/admin/listings/update/form/constants",
    component: _aca6e018,
    name: "admin-listings-update-form-constants"
  }, {
    path: "/admin/listings/update/form/controls",
    component: _5d89f9ef,
    name: "admin-listings-update-form-controls"
  }, {
    path: "/admin/listings/update/form/listing-item",
    component: _75b91eb4,
    name: "admin-listings-update-form-listing-item"
  }, {
    path: "/admin/listings/update/services/AdminUpdateListingTableMapService",
    component: _55441051,
    name: "admin-listings-update-services-AdminUpdateListingTableMapService"
  }, {
    path: "/admin/listings/update/table/checkbox-cell",
    component: _de510432,
    name: "admin-listings-update-table-checkbox-cell"
  }, {
    path: "/admin/listings/update/table/constants",
    component: _c30dd63c,
    name: "admin-listings-update-table-constants"
  }, {
    path: "/admin/listings/update/table/enums",
    component: _28821c7f,
    name: "admin-listings-update-table-enums"
  }, {
    path: "/admin/listings/update/table/header",
    component: _139c47e2,
    name: "admin-listings-update-table-header"
  }, {
    path: "/admin/listings/update/table/mixins/AdminListingsUpdateTableRowsProps",
    component: _b2379372,
    name: "admin-listings-update-table-mixins-AdminListingsUpdateTableRowsProps"
  }, {
    path: "/pro-marketplace/profile/:id",
    component: _495b2715,
    name: "pro-marketplace-profile-id"
  }, {
    path: "/pro-marketplace/view-request/:id",
    component: _dcdc5a72,
    name: "pro-marketplace-view-request-id"
  }, {
    path: "/buyer-checklist/:page",
    component: _84cdc1e0,
    name: "buyer-checklist-page"
  }, {
    path: "/how-it-works/:id",
    component: _30a5f0b9,
    name: "how-it-works-id"
  }, {
    path: "/listing-editing/:id",
    component: _e8976fc2,
    name: "listing-editing-id"
  }, {
    path: "/listings/:id",
    component: _3796cd2a,
    name: "listings-id"
  }, {
    path: "/pro/:id",
    component: _bc2e2406,
    name: "pro-id"
  }, {
    path: "/seller-checklist/:page",
    component: _52399708,
    name: "seller-checklist-page"
  }, {
    path: "/settings/:section",
    component: _22f9c7b7,
    name: "settings-section"
  }, {
    path: "/sold-property/:id",
    component: _2bbf5bbe,
    name: "sold-property-id"
  }, {
    path: "/user/:id",
    component: _460128c7,
    name: "user-id"
  }, {
    path: "/listings/:id?/audit",
    component: _3fe3c112,
    name: "listings-id-audit"
  }, {
    path: "/listings/:id?/dashboard",
    component: _ecdbdb20,
    name: "listings-id-dashboard"
  }, {
    path: "/listings/:id?/submit-success",
    component: _bd182070,
    name: "listings-id-submit-success"
  }, {
    path: "/offers-old/:id/agreement",
    component: _7fbfdd68,
    name: "offers-old-id-agreement"
  }, {
    path: "/settings/:section?/enums",
    component: _59f7e495,
    name: "settings-section-enums"
  }, {
    path: "/listings/:id?/dashboard/enums",
    component: _7a1a245f,
    name: "listings-id-dashboard-enums"
  }, {
    path: "/listings/:id?/viewings/:type",
    component: _34ceffba,
    name: "listings-id-viewings-type"
  }, {
    path: "/users/:id/:section",
    component: _f265905a,
    name: "users-id-section"
  }, {
    path: "/",
    component: _0e3d8418,
    name: "index"
  }, {
    path: "/buyer-checklist",
    redirect: "/buyer-checklist/getting-ready",
    name: "/buyer-checklist"
  }, {
    path: "/how-it-works",
    redirect: "/how-it-works/seller",
    name: "/how-it-works"
  }, {
    path: "/howitworks",
    redirect: "/how-it-works/seller",
    name: "/howitworks"
  }, {
    path: "/listings",
    redirect: "/search",
    name: "/listings"
  }, {
    path: "/listings/:city/:community/:propertyType/:price/:id",
    redirect: "/listings/:id",
    name: "/listings/:city/:community/:propertyType/:price/:id"
  }, {
    path: "/logout",
    redirect: "/",
    name: "/logout"
  }, {
    path: "/error404",
    redirect: "/404-error",
    name: "/error404"
  }, {
    path: "/pro-:id-:companyname",
    redirect: "/pro/:id",
    name: "/pro-:id-:companyname"
  }, {
    path: "/profiles/:id",
    redirect: "/users/:id",
    name: "/profiles/:id"
  }, {
    path: "/seller-checklist",
    redirect: "/seller-checklist/getting-ready",
    name: "/seller-checklist"
  }, {
    path: "/start-listing",
    redirect: "/sell-your-home",
    name: "/start-listing"
  }, {
    path: "/terms",
    redirect: "/terms-of-service",
    name: "/terms"
  }, {
    path: "/whybode",
    redirect: "/why-bode",
    name: "/whybode"
  }, {
    path: "/who-we-are",
    redirect: "/whoweare",
    name: "/who-we-are"
  }, {
    path: "/offers/seller",
    redirect: "/offer-management-seller",
    name: "/offers/seller"
  }, {
    path: "/offers/buyer",
    redirect: "/offer-management-buyer",
    name: "/offers/buyer"
  }, {
    path: "/documents",
    redirect: "/offer-management-seller",
    name: "/documents"
  }, {
    path: "/list-your-home",
    redirect: "/list-home",
    name: "/list-your-home"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
